import { c as _c } from "react/compiler-runtime";
import { calculateRequiredDonationAmount } from '@/app/donation/_utils/giftOrder';
import { useGiftOption } from '../../_context/GiftOptionContext';
type SelectedDonationAmountParams = {
  currentPrice?: number;
  requiredDonationAmount: number;
};
export const useSelectedDonationAmount = t0 => {
  const $ = _c(10);
  const {
    currentPrice: t1,
    requiredDonationAmount
  } = t0;
  const currentPrice = t1 === undefined ? 0 : t1;
  const {
    selectedOptions,
    quantity
  } = useGiftOption();
  let t2;
  if ($[0] !== selectedOptions) {
    t2 = Array.from(selectedOptions.values()).reduce(_temp, 0);
    $[0] = selectedOptions;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const totalExtraProductPrice = t2;
  let t3;
  if ($[2] !== currentPrice || $[3] !== requiredDonationAmount || $[4] !== selectedOptions.size || $[5] !== totalExtraProductPrice) {
    t3 = selectedOptions.size > 0 ? calculateRequiredDonationAmount(currentPrice + totalExtraProductPrice) : requiredDonationAmount;
    $[2] = currentPrice;
    $[3] = requiredDonationAmount;
    $[4] = selectedOptions.size;
    $[5] = totalExtraProductPrice;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const unitDonationAmount = t3;
  const t4 = unitDonationAmount * quantity;
  let t5;
  if ($[7] !== t4 || $[8] !== unitDonationAmount) {
    t5 = {
      unitDonationAmount,
      totalDonationAmount: t4
    };
    $[7] = t4;
    $[8] = unitDonationAmount;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
function _temp(total, option) {
  return total + option.extraProductPrice;
}